<div class="d-flex flex-dir-column align-items-center no-print m-t-1" [ngStyle]="{'margin-bottom': showCookiePopover ? '2em' : '0'}">
  <div>Powered by Migration Manager - Copyright © {{ currentYear }}</div>
  <div><a routerLink="" class="link-button" (click)="showPortalSecurityPopup()">About Portal Security </a></div>
</div>

<div class="cookie-popover no-print" *ngIf="showCookiePopover">
    <div>
        This website uses cookies to ensure you get the best experience on our website. <a routerLink="" class="link-button" (click)="showPortalSecurityPopup()"> Learn more </a>
    </div>
    <button mat-flat-button class="m-l-1" (click)="dismissCookiePopover()">Got it!</button>
</div>